import { BaseDto } from './base.dto';

export class MerchantFavoriteDto extends BaseDto {
  merchantFavoriteId: number;
  merchantId: number;
  groupName: string;
  sequence: number;
  startDate: Date;
  endDate: Date;
}
